/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Book_LessonsInputs */

const en_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book Lessons`)
};

const es_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservar lecciones`)
};

const de_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchen Sie Unterricht`)
};

const zh_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预订课程`)
};

const ar_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احجز دروساً`)
};

const fr_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réserver des leçons`)
};

const vi_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt buổi học`)
};

const sw_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weka nafasi ya masomo`)
};

const th_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จองบทเรียน`)
};

const bs_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervišite lekcije`)
};

const ja_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスン予約`)
};

const ko_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레슨 예약`)
};

const pt_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agendar aulas`)
};

const it_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenota lezioni`)
};

const sv_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boka lektioner`)
};

const nl_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lessen boeken`)
};

const da_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book lektioner`)
};

const nb_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestill timer`)
};

const fi_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varaa oppitunteja`)
};

const pl_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwuj lekcje`)
};

const ru_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Записаться на уроки`)
};

const tr_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ders rezervasyonu yap`)
};

const hi_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठ बुक करें`)
};

const id_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan pelajaran`)
};

const ms_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempah pelajaran`)
};

const cs_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervovat lekce`)
};

const el_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κλείστε μαθήματα`)
};

const he_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הזמנת שיעורים`)
};

const af_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bespreek lesse`)
};

const hu_prices_book_lessons = /** @type {(inputs: Prices_Book_LessonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Órák foglalása`)
};

/**
* | output |
* | --- |
* | "Book Lessons" |
*
* @param {Prices_Book_LessonsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_book_lessons = /** @type {((inputs?: Prices_Book_LessonsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Book_LessonsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_book_lessons(inputs)
	if (locale === "de") return de_prices_book_lessons(inputs)
	if (locale === "zh") return zh_prices_book_lessons(inputs)
	if (locale === "ar") return ar_prices_book_lessons(inputs)
	if (locale === "fr") return fr_prices_book_lessons(inputs)
	if (locale === "vi") return vi_prices_book_lessons(inputs)
	if (locale === "sw") return sw_prices_book_lessons(inputs)
	if (locale === "th") return th_prices_book_lessons(inputs)
	if (locale === "bs") return bs_prices_book_lessons(inputs)
	if (locale === "ja") return ja_prices_book_lessons(inputs)
	if (locale === "ko") return ko_prices_book_lessons(inputs)
	if (locale === "pt") return pt_prices_book_lessons(inputs)
	if (locale === "it") return it_prices_book_lessons(inputs)
	if (locale === "sv") return sv_prices_book_lessons(inputs)
	if (locale === "nl") return nl_prices_book_lessons(inputs)
	if (locale === "da") return da_prices_book_lessons(inputs)
	if (locale === "nb") return nb_prices_book_lessons(inputs)
	if (locale === "fi") return fi_prices_book_lessons(inputs)
	if (locale === "pl") return pl_prices_book_lessons(inputs)
	if (locale === "ru") return ru_prices_book_lessons(inputs)
	if (locale === "tr") return tr_prices_book_lessons(inputs)
	if (locale === "hi") return hi_prices_book_lessons(inputs)
	if (locale === "id") return id_prices_book_lessons(inputs)
	if (locale === "ms") return ms_prices_book_lessons(inputs)
	if (locale === "cs") return cs_prices_book_lessons(inputs)
	if (locale === "el") return el_prices_book_lessons(inputs)
	if (locale === "he") return he_prices_book_lessons(inputs)
	if (locale === "af") return af_prices_book_lessons(inputs)
	if (locale === "hu") return hu_prices_book_lessons(inputs)
	return en_prices_book_lessons(inputs)
});